import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              Shop by Category
            </h2>
            <p className="text-foreground-600 text-base md:text-lg font-light">
              Browse our curated fashion collections — trusted superbuy spreadsheet categories
            </p>
          </div>
          <Link
            to="/what-is-superbuy-spreadsheet/"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            View all guides
            <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden aspect-[4/5] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name} - Superbuy Spreadsheet`}
                title={`${cat.name} Superbuy Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-white text-base md:text-lg font-semibold mb-1">{cat.name}</h3>
                <p className="text-white/70 text-xs md:text-sm font-light">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}